export const sorts = {
  default: ['-filtered_gmv'],
  options: [
    {
      name: 'Filtered Links',
      key: 'filtered_active_links',
      options: [{ key: '-filtered_active_links', value: 'Most' }, { key: 'filtered_active_links', value: 'Least' }]
    },
    {
      name: 'Filtered Clicks',
      key: 'filtered_clicks',
      options: [{ key: '-filtered_clicks', value: 'Most' }, { key: 'filtered_clicks', value: 'Least' }]
    },
    {
      name: 'Filtered GMV',
      key: 'filtered_gmv',
      options: [{ key: '-filtered_gmv', value: 'Most' }, { key: 'filtered_gmv', value: 'Least' }]
    },
    {
      name: 'Filtered Sales per Click',
      key: 'filtered_gmv_per_click',
      options: [{ key: '-filtered_gmv_per_click', value: 'Most' }, { key: 'filtered_gmv_per_click', value: 'Least' }]
    },
    {
      name: 'Filtered Sales per Link',
      key: 'filtered_gmv_per_link',
      options: [{ key: '-filtered_gmv_per_link', value: 'Most' }, { key: 'filtered_gmv_per_link', value: 'Least' }]
    },
    {
      name: 'Filtered Conversion rate',
      key: 'filtered_conversion_rate',
      options: [{ key: '-filtered_conversion_rate', value: 'Most' }, { key: 'filtered_conversion_rate', value: 'Least' }]
    }
  ]
};